<template>
  <div class="content v-center">
    <Card>
      <Heading>Snart startar quizzet!</Heading>
      <h2>
        Så fort alla spelare gått med i partyt och skapat en egen avatar så
        startar quizledaren quizzet! Gå ingenstans!
      </h2>
    </Card>
  </div>
</template>

<script>
import { partyDb, firebaseApp } from '@/firebase';
import Card from '@/components/Card';
import Heading from '@/components/Heading';
import PARTY_BY_CODE from '@/graphql/PartyByCode.gql';

export default {
  apollo: {
    quiz: {
      query: PARTY_BY_CODE,
      variables() {
        return { code: sessionStorage.getItem('party_participant_code') };
      },
      update: data => {
        return data.partyByCode.quiz;
      }
    }
  },
  components: {
    Card,
    Heading
  },
  data() {
    return {
      party: false,
      partyCode: false,
      participantId: false
    };
  },
  watch: {
    party(newValue) {
      if (newValue.status === 1) {
        this.$router.push({ name: 'PartyQuiz' });
      } else if (newValue.status === 2) {
        this.$router.push({ name: 'PartyEnd' });
      }
    }
  },

  created: function() {
    const sessionCode = sessionStorage.getItem('party_participant_code');
    const sessionId = sessionStorage.getItem('party_participant_id');
    this.partyCode = sessionCode;
    this.participantId = sessionId;

    this.$binding('party', partyDb.collection('parties').doc(this.partyCode));
  },
  mounted() {
    firebaseApp.auth().onAuthStateChanged(user => {
      const uid = user.uid;

      // Kolla om användaren har laddat om sidan
      partyDb
        .doc('/participants/' + uid)
        .get()
        .then(doc => {
          const data = doc.data();
          if (data.partyCode == undefined) {
            // Uppdatera objektet
            partyDb.doc('/participants/' + uid).set(
              {
                partyCode: this.partyCode,
                answers: []
              },
              { merge: true }
            );
          }
        });
    });
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: #ff1232;
  font-size: 14/14 * 1rem;
}
</style>
